import { FunctionalComponent } from 'preact';
import clsx from 'clsx';
import { stylesheet } from 'astroturf';
import Heart from '##/assets/icons/icon-heart.svg';

const ADD_MORE_SHOWS_BANNER = 'Keep all of your favourites in one place';
const ADD_MORE_SHOWS_CONDENSED = 'Keep all of\n your favourites in\n one place';

const MyShowsBannerUrl = '/assets/images/MyShowsBanner.png';
const MyShowsCarouselUrl = '/assets/images/MyShowsCarousel.png';
const styles = stylesheet`
  @import '##/styles/import.scss';

  .add-more {
    width: 100%;
    background-image: url(${MyShowsBannerUrl});
    padding-left: pxToVw(125);
    background-repeat: no-repeat;
    background-size: cover;

    .content-container {
      padding: pxToVw(44) 0 0 pxToVw(184);
      display: block;
    }

    p {
      text-align: center;
      font-family: barlow;
      letter-spacing: pxToVw(0.2);
      font-size: pxToVw(19);
      color: $pure-white;
    }

    .button-container {
      width: pxToVw(166);
      height: pxToVw(38);
      font-size: pxToVw(16);
      letter-spacing: pxToVw(0.2);
      border-radius: pxToVw(27);
      opacity: 1;
      align-items: center;
      justify-content: center;
      border: pxToVw(1) solid $button-grey;
      display: flex;
      margin: pxToVw(10) auto;
    }

    &:global(.current-focus) {
      .button-container {
        background: transparent linear-gradient(270deg, $ten-enter-blue 0%, $ten-play-blue 100%) 0% 0% no-repeat padding-box;
        border: none;
      }
    }
  }

  .add-more-condensed {
    width: pxToVw(166);
    background-image: url(${MyShowsCarouselUrl});
    background-size: cover;
    padding-left: 0;

    .content-container {
      padding: pxToVw(24) pxToVw(15) 0 pxToVw(13);
      width: pxToVw(166)
    }

    p {
      white-space: pre;
      font-size: pxToVw(15);
      line-height: pxToVh(20);
      margin: pxToVh(14) auto;
    }

    .button-container {
      width: pxToVw(120);
      height: pxToVh(32);
      font-size: pxToVw(13);
    }

    svg {
      width: pxToVw(32);
      height: pxToVw(32);
      margin: pxToVh(20) auto pxToVh(10);
    }

    &:global(.current-focus) {
      transform: scale(1.1, 1.1);
      box-shadow: 0 0 0 pxToVw(2) $pure-white;
      border-radius: pxToVw(2);
    }
  }

  .centered {
    display: table;
    margin: pxToVh(23) auto;
  }

  .more-shows-heart {
    display: block;
    margin: auto;
    height: pxToVw(40);
    width: pxToVw(40);
  }
`;

export interface AddFavouritesTileProps {
  displayAsBanner: boolean;
}

export const AddFavouritesTile: FunctionalComponent<AddFavouritesTileProps> = ({
  displayAsBanner,
}) => (
  <div
    className={clsx(
      styles.addMore,
      !displayAsBanner && styles.addMoreCondensed,
    )}
  >
    <div className={styles.contentContainer}>
      <Heart className={styles.moreShowsHeart} />
      <p className={styles.centered}>
        {displayAsBanner ? ADD_MORE_SHOWS_BANNER : ADD_MORE_SHOWS_CONDENSED}
      </p>
      <div className={styles.buttonContainer}>Add More Shows</div>
    </div>
  </div>
);
